export const RESOURCES_QUERY_KEY = 'resources';
export const RESOURCE_QUERY_KEY = 'resource';
export const DOWNLOAD_FILE_QUERY_KEY = 'download-file';
export const USER_INFO_QUERY_KEY = 'user-info';
export const ALL_USERS_INFO_QUERY_KEY = 'all-user-info';
export const ORGANISATION_USAGE_QUERY_KEY = 'organisation-usage';
export const USER_USAGE_QUERY_KEY = 'user-usage';
export const SMART_ASSISTANTS_QUERY_KEY = 'smart-assistants';
export const SMART_ASSISTANT_QUERY_KEY = 'smart-assistant';
export const USER_SMART_ASSISTANT_CONVERSATIONS_QUERY_KEY = 'user-smart-assistant-conversations';
export const SMART_ASSISTANT_CONVERSATIONS_QUERY_KEY = 'smart-assistant-conversations';
export const SMART_ASSISTANT_LEADS_QUERY_KEY = 'smart-assistant-leads';
export const GUEST_SMART_ASSISTANT_QUERY_KEY = 'smart-assistant';
export const GUEST_SMART_ASSISTANT_WITH_INTEGRATIONS_QUERY_KEY = 'smart-assistant-with-integrations';
export const SMART_ASSISTANT_RESOURCES = 'smart-assistant-resources';
export const GUEST_SMART_ASSISTANT_TYPE_QUERY_KEY = 'guest-smart-assistant-type';
export const SUBSCRIPTION_QUERY_KEY = 'subscription';
export const MY_TEAMS_QUERY_KEY = 'my-teams';
export const OWNED_TEAMS_QUERY_KEY = 'owned-teams';
export const MEMBER_TEAMS_QUERY_KEY = 'members-teams';
export const GOOGLE_DRIVE_ACCOUNTS_QUERY_KEY = 'google-drive-accounts';
export const GOOGLE_DRIVE_FILES_QUERY_KEY = 'google-drive-files';
export const GOOGLE_DRIVE_SEARCH_QUERY_KEY = 'google-drive-search';
export const API_KEYS_QUERY_KEY = 'api-keys';
export const ZAPIER_API_KEYS_QUERY_KEY = 'zapier-api-keys';
export const SUBSCRIPTION_BALANCE_QUERY_KEY = 'subscription-balance';
export const BYOK_OPEN_ROUTER_QUERY_KEY = 'byok-open-router';
export const WHITE_LABEL_DOMAINS_QUERY_KEY = 'white-label-domains';
export const WHITE_LABEL_DOMAIN_QUERY_KEY = 'white-label-domain';
export const SHOPIFY_STORES_QUERY_KEY = 'shopify-stores';
export const RESOURCE_SHOPIFY_STORE_QUERY_KEY = 'resource-shopify-store';
export const SHOPIFY_STORE_QUERY_KEY = 'shopify-store';
export const SHOPIFY_STORE_PRODUCTS_COUNT_QUERY = 'shopify-store-product-count';
export const SHOPIFY_STORE_PRODUCTS_QUERY_KEY = 'shopify-store-products';
export const SHOPIFY_STORE_WEBSITE_QUERY_KEY = 'shopify-store-website';
export const WEBSITE_TEXT_DATA_QUERY_KEY = 'website-text-data';
export const SMART_ASSISTANT_BEHAVIOR_PROMPT_QUERY_KEY = 'smart-assistant-behavior-prompt';
export const WHATSAPP_ACCOUNTS_QUERY_KEY = 'whatsapp-accounts';
export const WHATSAPP_AVAILABLE_ACCOUNTS_QUERY_KEY = 'whatsapp-available-accounts';
export const SMART_ASSISTANT_BY_WHATSAPP_ACCOUNT_ID_QUERY_KEY = 'smart-assistant-by-whatsapp-account-id';
export const SMART_ASSISTANT_BY_WHATSAPP_PHONE_NUMBER_ID_QUERY_KEY = 'smart-assistant-by-whatsapp-phone-number-id';
export const VOICES_QUERY_KEY = 'voices';
export const FACEBOOK_ACCOUNTS_QUERY_KEY = 'facebook-accounts';
export const FACEBOOK_AVAILABLE_ACCOUNTS_QUERY_KEY = 'facebook-available-accounts';
export const SMART_ASSISTANT_BY_FACEBOOK_ACCOUNT_ID_QUERY_KEY = 'smart-assistant-by-facebook-account-id';
export const INSTAGRAM_ACCOUNTS_QUERY_KEY = 'instagram-accounts';
export const SMART_ASSISTANT_BY_INSTAGRAM_ACCOUNT_ID_QUERY_KEY = 'smart-assistant-by-instagram-account-id';
export const INSTAGRAM_AVAILABLE_ACCOUNTS_QUERY_KEY = 'instagram-available-accounts';
export const PHONE_NUMBERS_QUERY_KEY = 'phone-numbers';
export const EXTERNAL_PHONE_NUMBERS_QUERY_KEY = 'external-phone-numbers';
export const CONVERSATION_TAKEOVER_QUERY_KEY = 'conversation-takeover';
export const CALDOTCOM_ACCOUNTS_QUERY_KEY = 'caldotcom-accounts';
export const CALDOTCOM_EVENT_TYPES_QUERY_KEY = 'caldotcom-event-types';
export const POST_BILLING_PORTAL_SUMMARY_QUERY_KEY = 'post-billing-portal-summary';
export const RESOURCE_RAW_TEXT_QUERY_KEY = 'resource-raw-text';
export const EVALUATIONS_QUERY_KEY = 'evaluations';
